import axios from "axios";
import React, { useEffect, useState } from "react";
import { Dashboard_Client_Report } from "../../Configuration/API_URL";
import moment, { duration } from "moment";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
} from "../../CommonMethhods/CommonMethods";
import $ from "jquery";
import { Client_Search } from "../../Configuration/API_URL";
import Loader from "../../Components/Common/Loader";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import { Constants } from "../../CommonMethhods/Constants";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import { toast } from "react-toastify";
import SmallLoader from "../../Components/Common/smallLoader";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import { useDebounce } from "../../Components/useDebounce";

function SttReportSidebar() {
  const storeToken = localStorage.getItem("ssoToken");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [errorResp, setErrorResp] = useState("");
  const [nameError, setNameError] = useState("");
  const [page, setPage] = useState(1);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [scroll, setScroll] = useState(false);
  const [clientName, setClientName] = useState("");
  const [clientCode, setClientCode] = useState("");
  const [smallLoaderMail, setSmallLoaderMail] = useState(false);
  const [show, setShow] = useState(false);
  const [excelLoader, setExcelLoader] = useState(false);
  const [pdfLoader, setPdfLoader] = useState(false);
  const [selectedCode, setSelectedCode] = useState("");
  const [showCode, setShowCode] = useState("");
  const [showToDate, setShowToDate] = useState("");
  const [showFromDate, setShowFromDate] = useState("");
  const [fromDateError, setFromDateError] = useState("");
  const [toDateError, setToDateError] = useState("");

  const debouncedValue = useDebounce(clientCode, 1000);

  useEffect(()=>{
    handleClientName(debouncedValue);
  }, [debouncedValue]);

  const handleFromDate = (e) => {
    let c = e.target.value;
    if (!c) {
      setFromDate("");
      setFromDateError("Please select From Date");
      setShow(false);
      return;
    }
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    setFromDateError("");
  };

  const handleToDate = (e) => {
    let c = e.target.value;
    if (!c) {
      setToDate("");
      setToDateError("Please select To Date");
      setShow(false);
      return;
    }
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    setToDateError("");

    if (fromDate && checkDateRange(fromDate, d)) {
      setFromDateError("");
    }
  };

  const handleSearch = () => {
    if (!clientCode) {
      setNameError("Please select Client Name/Code");
      setShow(false);
      return;
    }
    if (!fromDate) {
      setFromDateError("Please select From Date");
      setShow(false);
      return;
    }
    if (!toDate) {
      setToDateError("Please select To Date");
      setShow(false);
      return;
    }
    if (!checkDateRange(fromDate, toDate)) {
      setFromDateError("From date should not exceed To date");
      setShow(false);
      return;
    }
    if (
      moment(toDate, "MM-DD-YYYY").diff(
        moment(fromDate, "MM-DD-YYYY"),
        "years",
        true
      ) > 1
    ) {
      setFromDateError("Maximum date range can be 1 year");
      setShow(false);
      return;
    }
    setShow(true);
    setShowCode(selectedCode);
    setShowFromDate(fromDate);
    setShowToDate(toDate);
    setFromDateError("");
  };

  async function searchApiDetail(e) {
    $(".write-search.contractList").addClass("show-result scroll-table");
    setScrollLoader(true);
    let payloadValue = {
      keyword: e.toUpperCase(),
      Status: "",
      PageNo: page,
      PageSize: 10,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getSearchDetail = await axios.post(
        Client_Search.Search_URL,

        `"${encPayload}"`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      const res = ApiResDecrypt(getSearchDetail?.data);

      if (res.message === "Client does not exist.") {
        setClientList([
          { clientname: "Client does not exist.", clientCode: null },
        ]);
      } else {
        if (scroll == true) {
          setClientList((prev) => {
            return [...prev, ...res.data.clients];
          });
        } else {
          setClientList(res.data.clients);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setScrollLoader(false);
    }
  }

  function clientSet(name, code, i) {
    if (name === "Client does not exist.") {
      $(".write-search.contractList").addClass("show-result scroll-table");
    } else {
      $(".write-search.contractList").removeClass("show-result");
      setClientList([]);
      setClientName(name);
      setClientCode(code);
      setSelectedCode(code);
      setScrollLoader(false);
    }
  }

  const handleClientName = (data) => {
    setScrollLoader(false);
    setNameError("");
    if (data) {
      setClientList([]);
      setScroll(false);
      // let result = data.toUpperCase();
      // setClientCode(result);
      if (data?.length > 3) {
        setPage(1);
        setClientList([]);
        setScroll(false);
        searchApiDetail(data);
      }
    } else {
      setClientList([]);
      setPage(1);
      setClientCode("");
      setScroll(false);
      // setNameError("Please select Client Name/Code");
      setShow(false);
      $(".write-search.contractList").removeClass("show-result");
    }
    $(".write-search.contractList-li").click(function () {
      $(".write-search.contractList").addClass("show-result scroll-table");
    });
  };

  const handleScroll = async () => {
    setScroll(true);
    const a = document.querySelector("#contractlist-scroll");
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
      setPage((prev) => prev + 1);
      setScrollLoader(true);
      searchApiDetail(clientCode);
    }
  };

  const getSTTReport = async (fileType) => {
    fileType === "pdf"
      ? setPdfLoader(true)
      : fileType === "excel"
      ? setExcelLoader(true)
      : setSmallLoaderMail(true);
    const payloadValue = {
      clientCode: showCode,
      fromDate: showFromDate,
      toDate: showToDate,
      fileType,
    };
    const encPayload = AESEncryption(payloadValue);
    try {
      let response = await axios.post(
        Dashboard_Client_Report.STT_Report,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      response = ApiResDecrypt(response?.data);
      if (response.status === 0) {
        if (fileType === "pdf")
          window.open(response?.data, "_blank", "noopener,noreferrer");
        else if (fileType === "excel")
          window.open(response?.data, "_self", "noopener,noreferrer");
        else if (fileType === "mail") toast.success("Email sent successfully!");
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setExcelLoader(false);
      setPdfLoader(false);
      setSmallLoaderMail(false);
    }
  };

  return (
    <>
      <Header portal={"RM"} />
      <SingleSignOnSideBar />
      <main id="main-content" className="reports">
        <div className="card-box">
          <div>
            <h2 className="report-title">STT Report</h2>
          </div>
          <div className="row input-field-wrapper">
            <div className="col-md-3 col-sm-4 col-12">
              <div className="form-group">
                <label className="form-label">Client Search:</label>
                <div className="input-text-wrapper align-items-center">
                  <input
                    id="input1"
                    type="text"
                    className="input-text form-control"
                    placeholder="Search by Name/ Code"
                    value={clientCode}
                    onChange={(e) => {
                      setClientCode(e?.target?.value?.toUpperCase())
                      setNameError("")
                      // handleClientName(e);
                    }}
                    onInput={(e) => {
                      const start = e.target.selectionStart;
                      const end = e.target.selectionEnd;
                      let input = e.target.value;
                      input = input
                          .toUpperCase()
                          .replace(/[^A-Z0-9\s]/g, "")
                          .replace(/\s+/g, " ")
                          .trimStart()
                          .slice(0, 100);

                      e.target.value = input;
                      e.target.setSelectionRange(start, end);
                  }}
                  />

                  <ul
                    className="write-search contractList border-0"
                    id="contractlist-scroll"
                    onScroll={handleScroll}
                  >
                    {clientList.map((item, i) => (
                      <li
                        key={i}
                        onClick={() =>
                          clientSet(item.clientname, item.clientCode, i)
                        }
                      >
                        <div> {item.clientname}</div>
                        <div>{item.clientCode}</div>
                      </li>
                    ))}
                    {scrollLoader && (
                      <div className="loader-center">
                        <LoaderForSearch />
                      </div>
                    )}
                  </ul>
                </div>
                <span
                  className="to-date-error"
                  style={{ marginBottom: "13px" }}
                >
                  {nameError}
                </span>
              </div>
            </div>
            <div className="col-md-3 col-sm-3 col-6">
              <div className="form-group calendar-icon">
                <label className="form-label">From Date:</label>
                <div>
                  <input
                    type="date"
                    placeholder="DD/MM/YYYY"
                    className="datepicker form-control"
                    id="ToDateCombine"
                    onChange={handleFromDate}
                    max={new Date().toISOString().split("T")[0]}
                  />
                  <span className="icon-calendar ico"></span>
                </div>
              </div>
              {fromDateError && (
                <span
                  className="duration-date-error"
                  style={{ marginBottom: "3px" }}
                >
                  {fromDateError}
                </span>
              )}
            </div>
            <div className="col-md-3 col-sm-3 col-6">
              <div className="form-group calendar-icon">
                <label className="form-label">To Date:</label>
                <div>
                  <input
                    type="date"
                    placeholder="DD/MM/YYYY"
                    className="datepicker form-control"
                    id="ToDateCombine"
                    onChange={handleToDate}
                    max={new Date().toISOString().split("T")[0]}
                  />
                  <span className="icon-calendar ico"></span>
                </div>
              </div>
              {toDateError && !toDate && (
                <span
                  className="duration-date-error"
                  style={{ marginBottom: "3px" }}
                >
                  {toDateError}
                </span>
              )}
            </div>
          </div>
          <div className="text-center search-btn-wrapper">
            <button
              value="grid"
              className="send-message"
              onClick={handleSearch}
            >
              {Constants.Search}
            </button>
          </div>
          <div className="for-grid-section">
            {false ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : (
              show && (
                <div className="mt-5 ipo-table-container">
                  <table className="ipo-table">
                    <thead>
                      <tr>
                        <th scope="col">Sr No.</th>
                        <th scope="col">ONL ID</th>
                        <th scope="col">From Date</th>
                        <th scope="col">To Date</th>
                        <th scope="col">Download</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>{showCode}</td>
                        <td>{showFromDate}</td>
                        <td>{showToDate}</td>
                        <td style={{ width: "350px" }}>
                          <div
                            className="d-flex justify-content-center"
                            style={{ gap: "10px" }}
                          >
                            <button
                              className="generate-btn text-green"
                              value="excel"
                              onClick={() => getSTTReport("excel")}
                            >
                              {excelLoader ? (
                                <SmallLoader />
                              ) : (
                                <>
                                  <span className="icon-excelsvg"></span>
                                  {"Excel"}
                                </>
                              )}
                            </button>

                            <button
                              className="generate-btn"
                              value="pdf"
                              style={{ color: "#886cc0" }}
                              onClick={() => getSTTReport("pdf")}
                            >
                              {pdfLoader ? (
                                <SmallLoader />
                              ) : (
                                <>
                                  <span className="icon-pdfsvg"></span>
                                  {"PDF"}
                                </>
                              )}
                            </button>

                            <button
                              className="generate-btn"
                              value="mail"
                              onClick={() => getSTTReport("mail")}
                              style={{ color: "#FFCD4A" }}
                            >
                              {smallLoaderMail ? (
                                <SmallLoader />
                              ) : (
                                <>
                                  <span className="icon-email"></span>
                                  {"E-Mail"}
                                </>
                              )}
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default SttReportSidebar;
